module.exports = __webpack_public_path__ + "media/packs/shared/logo-99703ee4753ad84e04cb7056c8f9c476.svg";